import * as React from 'react';

const BurgerIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 192" {...props}>
    <path d="M30 90h132v12H30zM30 42h132v12H30zM30 138h132v12H30z" />
  </svg>
);

export default BurgerIcon;
